import { native as en_native } from "../en/native";

/** native — RU slice. */
export const native: Record<keyof typeof en_native, string> = {
  // Discover tab + nearby map
  native_discover_title: "Обзор",
  native_discover_people_nearby: "Люди рядом",
  native_discover_finding_people: "Ищем людей рядом...",
  native_discover_start_swiping: "Свайпай, чтобы знакомиться",
  native_discover_none_nearby: "Рядом пока никого нет. Загляни позже!",
  native_discover_within_radius: "{count} {noun} в радиусе {radius} миль",
  native_discover_count_nearby: "{count} {noun} рядом",
  native_discover_person: "человек",
  native_discover_people: "человек",
  native_discover_location_unavailable: "Геолокация недоступна",
  native_discover_spots_nearby: "{count} мест рядом",
  native_discover_map_mobile_only: "Карта доступна в приложении",

  // Settings — push notification status
  native_settings_push_not_supported: "Не поддерживается на этом устройстве",
  native_settings_push_permission_denied: "Доступ запрещён",
  native_settings_push_enabled: "Включены",
  native_settings_push_disabled: "Выключены",

  // Settings — business section
  native_settings_business_section: "Бизнес",
  native_settings_business_mode_title: "Бизнес-режим",
  native_settings_business_mode_subtitle: "Создай или управляй своим бизнесом",

  // Settings — mini apps section
  native_settings_mini_apps_section: "Мини-приложения",
  native_settings_manage_mini_apps_title: "Управление мини-приложениями",
  native_settings_manage_mini_apps_subtitle:
    "Просматривай, создавай и управляй мини-приложениями",

  // Chat
  native_chat_no_messages_title: "Пока нет сообщений",
  native_chat_no_messages_description:
    "Когда у тебя появится совпадение, здесь можно будет начать разговор",
  native_chat_tap_to_retry: "Нажми, чтобы повторить",

  // Match / filters / match-location
  native_match_approximate_location: "Примерное местоположение",
  native_match_approximate_location_help:
    "Когда включено, другие видят только примерную зону рядом с вами, а не точное место. Точное местоположение не передаётся.",
  native_match_invalid_match: "Неверное совпадение",
  native_match_you_label: "Ты:",

  // Mini app view
  native_miniapp_load_failed: "Не удалось загрузить {appId}",
  native_miniapp_retry: "Повторить",
};
